import React from "react";
import AWSConnectionDrawer from "./AWSConnectionDrawer";
import AzureConnectionDrawer from "./AzureConnectionDrawer";
import GCPConnectionDrawer from "./GCPConnectionDrawer";
import TrutoIntegrationConnectionDrawer from "./TrutoIntegrationConnectionDrawer";
import WatchTowerConnectionDrawer from "./WatchTowerConnectionDrawer";
import { MasterLookupItemsType } from "../../../../utils/enums";
/**
 * Router component that renders the appropriate integration drawer
 * based on the integrationKey prop
 */
const IntegrationConnectionDrawer = ({
  open,
  onClose,
  integrationKey,
  integrationLabel,
  integrationLogo,
  domainKey,
  refetchIntegrationDetails,
  onStoreIntegrationDetails,
  onShowSnackbar,
}) => {
  const showError = (message) => {
    if (onShowSnackbar) {
      onShowSnackbar({
        message,
        vertical: "top",
        horizontal: "right",
      });
    }
  };

  const isIdpIntegration = domainKey === MasterLookupItemsType.IDP_PROVIDER;

  if (isIdpIntegration) {
    const idpConfig = {
      heading: `Connect ${integrationLabel}`,
      subtitle: `Follow the steps below to establish a secure connection with ${integrationLabel}`,
      steps: [],
      alert: {
        severity: "info",
        title: "Important: Admin or Delegate Admin Account Required",
        message: `To connect this integration, you'll need to sign in with an admin or delegate admin account from ${integrationLabel}. This ensures we can properly sync user data and manage access.`,
      },
      beforeConnecting: [
        `Sign in with an admin account from your ${integrationLabel} organization`,
        "Grant necessary permissions for user directory access",
        "Authorize the connection to sync user data",
      ],
    };

    return (
      <TrutoIntegrationConnectionDrawer
        open={open}
        onClose={onClose}
        integrationKey={integrationKey}
        integrationLabel={integrationLabel}
        integrationLogo={integrationLogo}
        refetchIntegrationDetails={refetchIntegrationDetails}
        config={idpConfig}
        onError={showError}
      />
    );
  }

  switch (integrationKey) {
    case "rego_watch_tower":
      return (
        <WatchTowerConnectionDrawer
          open={open}
          onClose={onClose}
          integrationLabel={integrationLabel}
          refetchIntegrationDetails={refetchIntegrationDetails}
        />
      );
    case "aws":
      return (
        <AWSConnectionDrawer
          open={open}
          onClose={onClose}
          refetchIntegrationDetails={refetchIntegrationDetails}
          onStoreIntegrationDetails={onStoreIntegrationDetails}
        />
      );
    case "azure":
      return (
        <AzureConnectionDrawer
          open={open}
          onClose={onClose}
          refetchIntegrationDetails={refetchIntegrationDetails}
          onStoreIntegrationDetails={onStoreIntegrationDetails}
        />
      );
    case "gcp":
      return (
        <GCPConnectionDrawer
          open={open}
          onClose={onClose}
          refetchIntegrationDetails={refetchIntegrationDetails}
          onStoreIntegrationDetails={onStoreIntegrationDetails}
        />
      );
    default:
      return null;
  }
};

export default IntegrationConnectionDrawer;
